import React from 'react';
import { FaRocket, FaRupeeSign, FaPalette, FaHandsHelping, FaChartLine, FaShieldAlt } from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaRocket />,
      title: 'Fast Delivery',
      description: 'Get your project live quickly without compromising quality.'
    },
    {
      icon: <FaRupeeSign />,
      title: 'Affordable Pricing',
      description: 'Premium development starting at just ₹4,999.'
    },
    {
      icon: <FaPalette />,
      title: 'Modern UI/UX',
      description: 'Beautiful, intuitive designs that users love and trust.'
    },
    {
      icon: <FaHandsHelping />,
      title: 'End-to-End Execution',
      description: 'From concept to deployment — everything is handled by us.'
    },
    {
      icon: <FaChartLine />,
      title: 'Scalable Architecture',
      description: 'Your system grows effortlessly as your user base grows.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Transparent & Honest',
      description: 'No hidden charges. No shortcuts. Only clean work that lasts.'
    }
  ];

  return (
    <section id="why-choose-us" className="why-choose-us">
      <div className="why-choose-us-container">
        <div className="why-choose-us-header" data-aos="fade-up">
          <h2 className="section-title">Why Businesses Trust Shawave Technologies</h2>
          <p className="section-subtitle">
            We are committed to delivering excellence and building long-term partnerships.
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;

